// Module
var code = `<div class="project-warning" ng-if="vm.warningMessage">{{vm.warningMessage}}<span class="close-button" ng-click="vm.closeWarning()"><i class="fa fa-close"></i></span></div> <survey-modal platforms="vm.platforms" survey-manager="vm.surveyManager" ng-if="vm.surveyReference"></survey-modal> `;
// Exports
export default code;